<template>
    <div id="goTop">
        <div 
            v-show="goTopShow" 
            class="goTop" 
            @click="goTop"
        >
            <i class="iconfont el-for1fanhuidingbu goTopIcon" />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            scrollTop: "",
            goTopShow: false
        };
    },
    watch: {
        scrollTop() {
            if (this.scrollTop > 500) {
                this.goTopShow = true;
            } else {
                this.goTopShow = false;
            }
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            if (this.scrollTop > 500) {
                this.goTopShow = true;
            }
        },
        goTop() {
            let timer = null,
                _that = this;
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(function fn() {
                if (_that.scrollTop > 0) {
                    _that.scrollTop -= 50;
                    document.body.scrollTop = document.documentElement.scrollTop =
                        _that.scrollTop;
                    timer = requestAnimationFrame(fn);
                } else {
                    cancelAnimationFrame(timer);
                    _that.goTopShow = false;
                }
            });
        }
    }, 
};
</script>
 
<style scoped>
.goTop {
    position: fixed;
    right: 50px;
    bottom: 60px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    box-sizing: border-box;
    box-shadow: 1px 1px 8px rgba(17, 26, 101,.3);
    text-align: center;
    line-height: 44px;
}
.goTop:hover .goTopIcon {
    color:rgba(17, 26, 101,1);
}
.goTopIcon {
    font-size: 22px;
    font-weight: bolder;
    color: rgba(17, 26, 101,.8);
}
</style>
